export const HEADINGS = [
  ["name", "Organisation Name"],
  ["0-7", "0-7"],
  ["7-13", "7-15"],
  ["14-20", "14-22"],
  ["21+", "21+"],
  ["total", "Total"],
];
